/** Partner embed — user arrived with ?token= and uses partner API. */
export function isPartnerSession(): boolean {
  return !!localStorage.getItem("jtoken");
}

export const PARTNER_CHECKOUT_STORAGE_KEY = "PartnerCheckoutPayload";

/**
 * Yelo Payfort checkout — only this token (and same user_id / yelo_checkout JWT claim).
 * Regular Jeeny partner tokens keep the Jeeny redirect payment flow.
 */
const YELO_CHECKOUT_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6eyJ1c2VyX2lkIjoidGVzdC1qZWVueS11c2VyLTAwMSIsImZpcnN0X25hbWUiOiJUZXN0IiwibGFzdF9uYW1lIjoiVXNlciIsInBob25lX251bWJlciI6Iis5NjY1MDAwMDAwMDAifSwiaWF0IjoxNzgyNzE3Mzg5fQ.K2E5SRupQ5EHQuj1EfuTxJ6N-NNqTdosuCXUNWY5pao";

const YELO_CHECKOUT_USER_ID = "test-jeeny-user-001";

export function getPartnerTokenFromStorage(): string {
  return (localStorage.getItem("jtoken") || "").replace(/^Bearer\s+/i, "");
}

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const raw = token.replace(/^Bearer\s+/i, "").split(".")[1];
    if (!raw) return null;
    const json = atob(raw.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

function jwtIndicatesYeloCheckout(token: string): boolean {
  const decoded = decodeJwtPayload(token);
  if (!decoded) return false;
  if (decoded.yelo_checkout === true) return true;

  const id = decoded.id as Record<string, unknown> | undefined;
  if (id?.yelo_checkout === true) return true;

  return false;
}

/** True only for the dedicated Yelo checkout partner token — not all Jeeny tokens. */
export function isYeloCheckoutToken(token?: string): boolean {
  const raw = (token || getPartnerTokenFromStorage()).replace(/^Bearer\s+/i, "").trim();
  if (!raw) return false;
  if (raw === YELO_CHECKOUT_TOKEN) return true;
  if (jwtIndicatesYeloCheckout(raw)) return true;

  const id = decodeJwtPayload(raw)?.id as Record<string, unknown> | undefined;
  return id?.user_id === YELO_CHECKOUT_USER_ID;
}

export function isYeloCheckoutSession(): boolean {
  return isPartnerSession() && isYeloCheckoutToken();
}

/** Keep ?token= on navigations for the Yelo checkout token only. */
export function withPartnerToken(path: string): string {
  if (!isYeloCheckoutSession()) return path;

  const token = getPartnerTokenFromStorage();
  if (!token) return path;

  const hashIndex = path.indexOf("#");
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : "";
  const pathAndQuery = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
  const queryIndex = pathAndQuery.indexOf("?");
  const pathname = queryIndex >= 0 ? pathAndQuery.slice(0, queryIndex) : pathAndQuery;
  const query = queryIndex >= 0 ? pathAndQuery.slice(queryIndex + 1) : "";

  const params = new URLSearchParams(query);
  if (!params.has("token")) {
    params.set("token", token);
  }

  const qs = params.toString();
  return `${pathname}${qs ? `?${qs}` : ""}${hash}`;
}

export function partnerHomePath(): string {
  return withPartnerToken("/");
}
